import React, { useState, useEffect }  from 'react';
import { useParams } from 'react-router';
import { useDispatch } from 'react-redux';
import { useAppContext } from 'context/AppContext';
import { makeStyles } from 'styles/util';
import { handleResponse } from 'actions/actionHelpers';
import { fetchNewsArticle } from 'actions/newsArticles';
import strings from 'localization/strings';
import { formatShortDate } from 'helpers/DateHelper';
import { useScrollToTop } from 'helpers/BrowserHelper';

import Container from 'common/Container';
import PageTitle from 'common/PageTitle';
import Typography from '@material-ui/core/Typography';
import Loader from 'common/Loader';
import Text from 'common/Text';
import MarginBox from 'common/MarginBox';

const useStyles = makeStyles(() => ({
    leadParagraph: {
        '& img': {
            width: '100%'
        }
    }
}));

const NewsArticlePage = () => {
    const classes = useStyles();
    const params = useParams();
    const dispatch = useDispatch();
    const { appContext } = useAppContext();
    const [isLoading, setIsLoading] = useState(true);
    const [newsArticle, setNewsArticle] = useState();

    useEffect(() => {
        dispatch(fetchNewsArticle(params.newsArticleId))
            .then(handleResponse(
                response => {
                    setIsLoading(false);
                    setNewsArticle(response.payload);
                },
                () => {
                    setIsLoading(false);
                }
            ));
    }, [params.newsArticleId]);

    useScrollToTop();

    return (
        <Container withPageMargins maxWidth="1000px">
            {
                isLoading && <Loader />
            }
            {
                !isLoading && newsArticle &&
                (
                    <>
                        <PageTitle>{newsArticle.title}</PageTitle>

                        <Typography variant="h1" gutterBottom>
                            {newsArticle.title}
                        </Typography>

                        <Typography variant="body2" gutterBottom>
                            {strings.formatString(strings.publishedAtX, formatShortDate(newsArticle.publicationDate, appContext))}
                        </Typography>

                        <MarginBox bottom={2}>
                            <Text html={newsArticle.leadParagraph} className={classes.leadParagraph}/>
                        </MarginBox>

                        <Text html={newsArticle.body}/>
                    </>
                )
            }
        </Container>
    );
};

export default NewsArticlePage;
